module.exports = __webpack_public_path__ + "img/03-ball-1-base.1a304a38.svg";